<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-card(flat)
          v-card-text.pa-0
            v-btn(color="primary" @click="update")
              v-icon(left) save
              span 調整登録
            table.app-table-basic-slim
              thead
                tr
                  th.w120px 名称
                  th.w60px W
                  th.w60px H
                  th.w60px D
                  th.w60px 枚数
                  th.hidden-xs-only 上
                  th.hidden-xs-only 右
                  th.hidden-xs-only 下
                  th.hidden-xs-only 左
                  th.w160px 木取情報出力
                  th.w160px ラベル出力
              tbody(v-for="(face, faceIndex) in box.order_faces" :key="faceIndex")
                tr(v-for="(board, boardIndex) in face.order_boards" :key="boardIndex")
                  td {{board.code}}
                  td.align-right {{board.x}}
                  td.align-right {{board.y}}
                  td.align-right {{board.osb.thick}}
                  td.align-right {{board.quantity * box.input.overview.quantity}}
                  td.hidden-xs-only
                    span.rem8 {{board.top_edge.program_no}}
                    span.rem8.hidden-sm-and-down :{{board.top_edge.description}}
                  td.hidden-xs-only
                    span.rem8 {{board.right_edge.program_no}}
                    span.rem8.hidden-sm-and-down :{{board.right_edge.description}}
                  td.hidden-xs-only
                    span.rem8 {{board.bottom_edge.program_no}}
                    span.rem8.hidden-sm-and-down :{{board.bottom_edge.description}}
                  td.hidden-xs-only
                    span.rem8 {{board.left_edge.program_no}}
                    span.rem8.hidden-sm-and-down :{{board.left_edge.description}}
                  td.text-xs-center
                    v-checkbox.app-line-check(:input-value="board.output_csv" hide-details @change="updateBoard({\
                    token: token,\
                    boxIndex: boxIndex,\
                    faceIndex: faceIndex,\
                    boardIndex: boardIndex,\
                    board: {\
                    output_csv: $event,\
                    label_print: $event,\
                    }\
                    })")
                  td
                    v-checkbox.app-line-check(:input-value="board.label_print" hide-details @change="updateBoard({\
                    token: token,\
                    boxIndex: boxIndex,\
                    faceIndex: faceIndex,\
                    boardIndex: boardIndex,\
                    board: {label_print: $event}\
                    })" :disabled="!board.output_csv")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['token', 'boxIndex'],
  data () {
    return {
      box: null
    }
  },
  created () {
    this.box = this.getBox(this.token, this.boxIndex)
  },
  computed: {
    ...mapGetters('app/list', ['getOrder', 'getBox'])
  },
  methods: {
    ...mapActions('app/list', ['updateBoard']),
    update () {
      let self = this
      self.$ajax.post('order/estimate', self.getOrder(self.token).json).then(function () {
        self.$toastr.success('登録しました。')
      })
    }
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/List/Components/Arrange.vue